(function() {
  if (window.customElements.get('etd-timeline')) return;

  function pad(n){return n<10?'0'+n:''+n}
  function isoDate(d){return d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate())}
  function isWeekend(d){var w=d.getDay();return w===0||w===6}
  function isSameDay(a,b){return a.getFullYear()===b.getFullYear()&&a.getMonth()===b.getMonth()&&a.getDate()===b.getDate()}
  function startOfDay(d){return new Date(d.getFullYear(),d.getMonth(),d.getDate(),0,0,0,0)}
  function addDays(d,n){var x=new Date(d.getTime());x.setDate(x.getDate()+n);return x}
  function parseCutoff(s){var m=/^\s*(\d{1,2}):(\d{2})\s*$/.exec(s||'');return m?{h:parseInt(m[1],10),m:parseInt(m[2],10)}:{h:13,m:0}}

  class EtdTimeline extends HTMLElement {
    connectedCallback() {
      var ds = this.dataset;
      this.cfg = {
        cutoff: ds.cutoff || '13:00',
        processingDays: parseInt(ds.processingDays || '0', 10),
        maxProcessing: parseInt(ds.maxProcessing || '0', 10),   /* ABD K4: hazırlık aralığı (5-7) */
        minTransit: parseInt(ds.minTransit || '1', 10),
        maxTransit: parseInt(ds.maxTransit || '3', 10),
        skipWeekends: ds.skipWeekends !== 'false',
        tzOffsetMin: parseInt(ds.tzOffsetMin || '0', 10),
        holidays: (ds.holidays || '').split(',').map(function(s){return s.trim()}).filter(Boolean),
        months: (ds.months || '').split(',').map(function(s){return s.trim()}).filter(Boolean),
        todayLabel: ds.todayLabel || 'TODAY',
        tomorrowLabel: ds.tomorrowLabel || 'TOMORROW',
        mondayLabel: ds.mondayLabel || 'PAZARTESİ',
        weekdays: (ds.weekdays ? ds.weekdays.split(',') : ['SUNDAY','MONDAY','TUESDAY','WEDNESDAY','THURSDAY','FRIDAY','SATURDAY']).map(function(x){return x.trim()}),
        bannerTop: ds.bannerTop || '',
        bannerBot: ds.bannerBot || '',
        hourUnit: ds.hourUnit || 'saat',
        minuteUnit: ds.minuteUnit || 'dk',
        secondUnit: ds.secondUnit || 'sn',
        tip3Template: ds.tip3 || ''
      };
      this.render();
      this.timer = setInterval(this.render.bind(this), 1000);
      this._bindMobileTooltips();
    }
    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
      if (this._docHandler) document.removeEventListener('click', this._docHandler);
    }
    _nowInTZ() {
      var n = new Date();
      return new Date(n.getTime() + (this.cfg.tzOffsetMin + n.getTimezoneOffset()) * 60000);
    }
    _isNonWorkingDay(d) {
      return (this.cfg.skipWeekends && isWeekend(d)) || this.cfg.holidays.indexOf(isoDate(d)) !== -1;
    }
    _rollForwardToWorkingDay(d) {
      var x = new Date(d.getTime());
      while (this._isNonWorkingDay(x)) x.setDate(x.getDate() + 1);
      return x;
    }
    _addBusinessDays(d, n) {
      var x = new Date(d.getTime()), added = 0;
      while (added < n) { x.setDate(x.getDate() + 1); if (!this._isNonWorkingDay(x)) added++; }
      return x;
    }
    _fmtDate(d) { return d.getDate() + (/^de/.test(document.documentElement.lang) ? '. ' : ' ') + (this.cfg.months[d.getMonth()] || ''); }
    _fmtRange(d1, d2) {
      if (isSameDay(d1, d2)) return this._fmtDate(d1);
      if (d1.getMonth() === d2.getMonth()) return d1.getDate() + (/^de/.test(document.documentElement.lang) ? '.-' : ' - ') + this._fmtDate(d2);
      return this._fmtDate(d1) + ' - ' + this._fmtDate(d2);
    }
    _fmtCountdown(diffMs) {
      if (diffMs <= 0) return '0 ' + this.cfg.hourUnit + ' 0 ' + this.cfg.minuteUnit + ' 0 ' + this.cfg.secondUnit;
      var t = Math.floor(diffMs / 1000), h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), s = t % 60;
      return h + ' ' + this.cfg.hourUnit + ' ' + m + ' ' + this.cfg.minuteUnit + ' ' + s + ' ' + this.cfg.secondUnit;
    }
    _compute() {
      var now = this._nowInTZ(), cut = parseCutoff(this.cfg.cutoff);
      var todayStart = startOfDay(now);
      var todayCutoff = new Date(todayStart.getTime());
      todayCutoff.setHours(cut.h, cut.m, 0, 0);
      var orderDate = new Date(now.getTime());
      var shipDate = (!this._isNonWorkingDay(now) && now < todayCutoff)
        ? startOfDay(now)
        : startOfDay(this._rollForwardToWorkingDay(addDays(now, 1)));
      if (this.cfg.processingDays > 0) shipDate = this._addBusinessDays(shipDate, this.cfg.processingDays);
      var shipMax = this.cfg.maxProcessing > this.cfg.processingDays ? this._addBusinessDays(shipDate, this.cfg.maxProcessing - this.cfg.processingDays) : shipDate;
      var dayLabel;
      if (isSameDay(shipDate, todayStart)) dayLabel = this.cfg.todayLabel;
      else if (isSameDay(shipDate, addDays(todayStart, 1))) dayLabel = this.cfg.tomorrowLabel;
      else if (shipDate.getDay() === 1) dayLabel = this.cfg.mondayLabel;
      else dayLabel = this.cfg.weekdays[shipDate.getDay()];
      var target = new Date(shipDate.getTime());
      target.setHours(cut.h, cut.m, 0, 0);
      if (now >= target) {
        target = startOfDay(this._rollForwardToWorkingDay(addDays(now, 1)));
        target.setHours(cut.h, cut.m, 0, 0);
      }
      return {
        now: now, orderDate: orderDate, shipDate: shipDate, target: target, dayLabel: dayLabel,
        deliveryMin: this._addBusinessDays(shipDate, this.cfg.minTransit),
        shipMax: shipMax,
        deliveryMax: this._addBusinessDays(shipMax, this.cfg.maxTransit)
      };
    }
    render() {
      var s = this._compute();
      var timeStr = this._fmtCountdown(s.target - s.now);
      var top = (this.cfg.bannerTop || '').replace('{time}', timeStr);
      var bot = (this.cfg.bannerBot || '').replace('{day}', '<span class="etd-day">' + s.dayLabel + '</span>');
      top = top.replace(timeStr, '<span class="etd-time">' + timeStr + '</span>');
      var rng = '<span class="etd-day">' + this._fmtRange(s.deliveryMin, s.deliveryMax) + '</span>';   /* ABD K4: sayaçsız teslim aralığı */
      top = top.replace('{date}', rng); bot = bot.replace('{date}', rng);
      var b = this.querySelector('[data-etd-banner]'); if (b) b.innerHTML = top + '<br>' + bot;
      var d1 = this.querySelector('[data-etd-date-1]'); if (d1) d1.textContent = this._fmtDate(s.orderDate);
      var d2 = this.querySelector('[data-etd-date-2]'); if (d2) d2.textContent = this._fmtRange(s.shipDate, s.shipMax);
      var d3 = this.querySelector('[data-etd-date-3]'); if (d3) d3.textContent = this._fmtRange(s.deliveryMin, s.deliveryMax);
      var t3 = this.querySelector('[data-etd-tooltip-3]');
      if (t3 && this.cfg.tip3Template) t3.textContent = this.cfg.tip3Template.replace('{date}', this._fmtRange(s.deliveryMin, s.deliveryMax));
    }
    _bindMobileTooltips() {
      var nodes = this.querySelectorAll('[data-etd-node]'), open = 'is-tooltip-open';
      nodes.forEach(function(node) {
        node.addEventListener('click', function(e) {
          if (window.matchMedia('(max-width: 749px)').matches) {
            var was = node.classList.contains(open);
            nodes.forEach(function(n) { n.classList.remove(open); });
            if (!was) node.classList.add(open);
            e.stopPropagation();
          }
        });
      });
      this._docHandler = function() { nodes.forEach(function(n) { n.classList.remove(open); }); };
      document.addEventListener('click', this._docHandler);
    }
  }
  customElements.define('etd-timeline', EtdTimeline);
})();